var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Bairro","placeholder":"Bairro","hide-details":""},on:{"change":_vm.onChange},model:{value:(_vm.bairroComplemento),callback:function ($$v) {_vm.bairroComplemento=$$v},expression:"bairroComplemento"}})}
var staticRenderFns = []

export { render, staticRenderFns }